import React, { Component } from 'react';
import Banner from './Banner';
import { FormattedMessage } from '../Intl';
import PropTypes from 'prop-types';

const HA_COOKIE_CONSENT = 'ha-cookie-consent';
const MAX_AGE = 365 * 86400000;

class CookieBanner extends Component {
  componentDidMount() {
    if (this.props.visible) {
      document.cookie = `${HA_COOKIE_CONSENT}=true;max-age=${MAX_AGE}`;
    }
  }

  render() {
    return (
      <FormattedMessage id={['page.cookies.banner', 'LinkUtilities.cookiesInfo']}>
        {(cookieText, cookieLink) => <Banner visible={this.props.visible} text={cookieText.replace('{0}', cookieLink)} />}
      </FormattedMessage>
    );
  }
}

CookieBanner.propTypes = {
  visible: PropTypes.bool.isRequired
};

export default CookieBanner;
